import styles from "./Reports.module.css";
import ResultAndCount from "../../components/ResultAndCount/ResultAndCount";
import SearchBar from "../../components/SearchBar/SearchBar";
import Dropdown from "../../components/Dropdown/Dropdown";
import { IoMdTrash } from "react-icons/io";
import Dynamic from "../../components/DynamicTable/DynamicTable";
import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { useState } from "react";
import PaginationTable from "../../components/PaginationTable/PaginationTable";
import LogoWithName from "../../components/LogoWithName/LogoWithName";
import Action from "../../components/Action/Action";
import { FaInstagram } from "react-icons/fa";
import IconAndName from "../../components/IconAndName/IconAndName";
import { RiFileTextLine } from "react-icons/ri";
import CopyRight from "../../components/CopyRight/CopyRight";
import { MdOutlineTextSnippet } from "react-icons/md";
import CalendarInput from "../../components/CalendarInput/CalendarInput";
import AssessmentReportsCard from "../../components/AssessmentReportsCard/AssessmentReportsCard";
import DataFilter from "../../components/DataFilter/DataFilter";


const data = [
  {
    _id: "1",
    name: "John Jacob",
    assessments: {
      Mathematics: { observations: 0, concerns: 0, reflections: 0 },
      Science: { observations: 1, concerns: 0, reflections: 0 },
      Social: { observations: 0, concerns: 0, reflections: 0 },
      English: { observations: 0, concerns: 0, reflections: 0 },
      Hindi: { observations: 0, concerns: 0, reflections: 0 },
    },
  },
  {
    _id: "2",
    name: "John Jasdkdcob",
    assessments: {
      Mathematics: { observations: 0, concerns: 0, reflections: 0 },
      Science: { observations: 1, concerns: 0, reflections: 0 },
      Social: { observations: 0, concerns: 0, reflections: 0 },
      English: { observations: 0, concerns: 0, reflections: 0 },
      Hindi: { observations: 0, concerns: 0, reflections: 0 },
    },
  },
  {
    _id: "2",
    name: "John Jasdksdcob",
    assessments: {
      Mathematics: { observations: 1, concerns: 1, reflections: 0 },
      Science: { observations: 1, concerns: 0, reflections: 0 },
      Social: { observations: 0, concerns: 0, reflections: 0 },
      English: { observations: 0, concerns: 0, reflections: 0 },
      Hindi: { observations: 0, concerns: 0, reflections: 0 },
    },
  },
  // Add more rows as needed
];
  

function Reports() {
  const [selectedDate, setSelectedDate] = useState("");
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);
  const [filters, setFilters] = useState([]);


  const handlecreateform = () => {
    dispatch(openModal("addFeePlan"));
  };
  const getColumnData = (data) => {
    const filteredData = data.filter((student) => {
      if (filters.length === 0) return true;

      return Object.values(student.assessments).some((subject) =>
        filters.some((key) => {
          if (key === "Observations") return subject.observations > 0;
          if (key === "Concerns") return subject.concerns > 0;
          if (key === "Reflections") return subject.reflections > 0;
          return false;
        })
      );
    });

    return filteredData.map((item) => ({
      name: (
        <LogoWithName
          name={item.name}
          icon={item.name[0]}
          iconBgColor="#E4EEFF"
          iconColor="#3E7BFA"
        />
      ),
      Mathematics: (
        <AssessmentReportsCard
          {...item.assessments.Mathematics}
          filters={filters}
        />
      ),
      Science: (
        <AssessmentReportsCard
          {...item.assessments.Science}
          filters={filters}
        />
      ),
      Social: (
        <AssessmentReportsCard {...item.assessments.Social} filters={filters} />
      ),
      English: (
        <AssessmentReportsCard
          {...item.assessments.English}
          filters={filters}
        />
      ),
      Hindi: (
        <AssessmentReportsCard {...item.assessments.Hindi} filters={filters} />
      ),
    }));
  };
  
  
  

  const displayData = getColumnData(data);

  const ActionsData = [
    {
      label: "Send Invite",
      onclick: () => {
        console.log("send invite");
      },
    },
    {
      label: "Update Rooms",
      onclick: () => {
        dispatch(openModal("updateRoom"));
      },
    },
    {
      label: "Update Status",
      onclick: () => {
        dispatch(openModal("statusUpdate"));
      },
    },
    {
      label: "Update Groups",
      onclick: () => {
        dispatch(openModal("updateGroups"));
      },
    },
    {
      label: "Transfer Student",
      onclick: () => {
        dispatch(openModal("TransferStudent"));
      },
    },
    {
      label: "Create Folder",
      onclick: () => {
        dispatch(openModal("createFolder"));
      },
    },
  ];

  const headingsData = [
    { title: "Student Name", accessor: "name" },
    { title: "Mathematics", accessor: "Mathematics" },
    { title: "Science", accessor: "Science" },
    { title: "Social", accessor: "Social" },
    { title: "English", accessor: "English" },
    { title: "Hindi", accessor: "Hindi" },
  ];
  

  return (
    <>
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.topRow}>
          <span className={styles.label}>Configure</span>
          <div className={styles.filterBar}>
            <DataFilter
              initialFilters={["Observations", "Concerns", "Reflections"]}
              placeholder=""
              onChange={(filters) => setFilters(filters)}
            />
          </div>
          <div className={styles.createForm}>
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Add"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
        </div>
      </div>

      {/* Search and Filters */}
      <div className={styles.totalstudentcard}>
        <div className={styles.studentsection}>
          <div className={styles.search}>
            <SearchBar
              placeholder="Search Student"
              onChange={(e) => console.log(e.target.value)}
            />
          </div>
          <div className={styles.filters}>
            <CalendarInput
              label="Date"
              value={selectedDate}
              onChange={setSelectedDate}
              background="var(--Utility_Color1)"
              textColor="gray"
              iconColor="gray"
              placeholderColor="gray"
              borderRadius="25px"
              shadow={false}
            />
            <Dropdown label="Program" options={["Live", "Inactive", "Draft"]} />
            <Dropdown label="Group" options={["Live", "Inactive", "Draft"]} />

            <Dropdown label="Room" options={["Live", "Inactive", "Draft"]} />
          </div>
        </div>

        {/* Student Data Table */}
        <div>
          <div className={styles.dynamicdata}>
            <Dynamic
              headings={headingsData}
              columnData={displayData.slice(
                (currentPage - 1) * itemsPerPage,
                currentPage * itemsPerPage
              )}
            />
          </div>
          <div className={styles.paginationTable}>
            <PaginationTable
              data={displayData}
              currentPage={currentPage}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              setItemsPerPage={setItemsPerPage}
            />
          </div>
        </div>
      </div>

     
    </div>
     <CopyRight />
     </>
  );
}

export default Reports;
